import React, { FC, useState } from 'react';
import Wizard from 'src/modules/generic/components/Wizard/v2';
import useActions from './hooks/useActions';
import useGuards from './hooks/useGuards';
import useServices from './hooks/useServices';
import useSteps from './hooks/useSteps';
import machine from './machine';
import { useLD } from 'src/providers/LDProvider';

interface Props {
  initialValues: any
  onPreviousMachine?: () => void
  goToChooseJurisdiction?: () => void
  onFinish: () => void
  onCancel: () => void
}

/* To Call this modal execute: openModal( AdgmTectStartupModal, {},'MODAL_ADGM_TECT_STARTUP' ); */
const AdgmTechStartupMachineWizard:FC<Props> = ({
  initialValues ={},
  onPreviousMachine,
  goToChooseJurisdiction,
  onFinish,
  onCancel,
}) => {

  const guards = useGuards();
  const actions = useActions({ onPreviousMachine, goToChooseJurisdiction });
  const steps = useSteps();
  const services = useServices();
  const ldProvider = useLD();
  const emergentTSLremoved = ldProvider.featureFlags['emergent-tsl-removal']
  
  return (
    <Wizard
      guards={guards}
      machine={machine(emergentTSLremoved)}
      steps={steps}
      services={services}
      actions={actions}
      onStopMachine={onFinish}
      onCancelMachine={onCancel}
    />

  );
};

export default AdgmTechStartupMachineWizard;
